// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "recovery.title": "Reset your password",
  "recovery.email": "Email",
  "recovery.send": "Send link",
  "recovery.sending": "Sending",
  "recovery.invalid": "That doesn’t look like an email address.",
  "recovery.accepted": "Check your email",
  "recovery.request": "Look for a reset link at {email}.",
  "recovery.back": "Back to sign in",
  "recovery.failed": "We couldn’t send the link.",
  "recovery.limited": "Try again later.",
} as const;
